import { render } from "./NewReportDetail.vue?vue&type=template&id=74ed7fc5"
import script from "./NewReportDetail.vue?vue&type=script&lang=js"
export * from "./NewReportDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__